import { render, staticRenderFns } from "./InsurerAddress.vue?vue&type=template&id=6a0dfb0d"
import script from "./InsurerAddress.vue?vue&type=script&lang=js"
export * from "./InsurerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0dfb0d')) {
      api.createRecord('6a0dfb0d', component.options)
    } else {
      api.reload('6a0dfb0d', component.options)
    }
    module.hot.accept("./InsurerAddress.vue?vue&type=template&id=6a0dfb0d", function () {
      api.rerender('6a0dfb0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerAddress.vue"
export default component.exports